import { InjectionToken } from '@angular/core';

export interface LanguageRegionToken {
  language: string;
  region: string;
}
export const LANGUAGE_REGION_TOKEN = new InjectionToken<LanguageRegionToken>('config-token');
